import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
const API = `${BACKEND_URL}/api`;

const SeasonNavigation = () => {
  const [seasons, setSeasons] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    fetchSeasons();
  }, []);

  const fetchSeasons = async () => {
    try {
      const response = await axios.get(`${API}/programming/seasons`);
      setSeasons(response.data.seasons || []);
    } catch (error) {
      console.error('Error fetching seasons:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return null;
  }

  const isStockActive = location.pathname === '/catalog' || location.pathname === '/';
  const isSeasonActive = (season) => location.pathname === `/programming/${season.toLowerCase()}`;

  return (
    <div className="flex items-center space-x-3">
      {/* STOCK Button */}
      <Link to="/catalog">
        <Button 
          className={`font-semibold ${
            isStockActive 
              ? 'bg-blue-600 hover:bg-blue-700 text-white' 
              : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
          }`}
        >
          📦 STOCK
        </Button>
      </Link>

      {/* Season Buttons */}
      {seasons.map((seasonData) => (
        <Link key={seasonData.season} to={`/programming/${seasonData.season.toLowerCase()}`}>
          <Button 
            className={`font-semibold ${
              isSeasonActive(seasonData.season)
                ? 'bg-blue-600 hover:bg-blue-700 text-white'
                : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
            }`}
          >
            📅 {seasonData.season}
          </Button>
        </Link>
      ))}
    </div>
  );
};

export default SeasonNavigation;
